import {BaseTrackingEvent} from '@udemy-v2/event-tracking';
//import {ClientEvent} from '@udemy-v2/event-tracking';

export class LandingPageCTASelected implements BaseTrackingEvent {
    readonly _type = 'LandingPageCTASelected';
    componentName: string;
    landingPage = 'indeed';

    constructor({componentName, pageFor}: {componentName: string; pageFor: string | null}) {
        if (pageFor) {
            this.componentName = componentName + '_' + pageFor;
        } else {
            this.componentName = componentName;
        }
    }
}

type RenewIntervalType = 'month' | 'day' | 'year' | 'week';

class SubscriptionPlanPricingOption {
    price: string;
    listPrice: string;
    currency: string;
    renewalIntervalType: RenewIntervalType;
    renewalIntervalCount: number;
    hasTrial: boolean;
    trialDays?: number | null;

    constructor({
        price,
        listPrice,
        currency,
        renewalIntervalType,
        renewalIntervalCount,
        hasTrial,
        trialDays,
    }: {
        price: string;
        listPrice: string;
        currency: string;
        renewalIntervalType: RenewIntervalType;
        renewalIntervalCount: number;
        hasTrial: boolean;
        trialDays?: number | null;
    }) {
        this.price = price;
        this.listPrice = listPrice;
        this.currency = currency;
        this.renewalIntervalType = renewalIntervalType;
        this.renewalIntervalCount = renewalIntervalCount;
        this.hasTrial = hasTrial;
        this.trialDays = trialDays;
    }
}

export class SubscriptionOfferPresented implements BaseTrackingEvent {
    readonly _type = 'SubscriptionOfferPresented';
    primaryPricingOption: SubscriptionPlanPricingOption;
    allPricingOptions: SubscriptionPlanPricingOption[];
    productType: 'consumer' | 'team';
    countryCode: string;
    courseId: number | null;
    courseTrackingId: string | null;
    badges: string[] | null;
    uiRegion: string;
    constructor({
        uiRegion,
        primaryPricingOption,
        countryCode,
        pageFor,
    }: {
        uiRegion: string;
        primaryPricingOption: SubscriptionPlanPricingOption;
        countryCode: string;
        pageFor: string | null;
    }) {
        this.primaryPricingOption = primaryPricingOption;
        this.allPricingOptions = [primaryPricingOption];
        this.productType = 'consumer';
        this.countryCode = countryCode;
        this.courseId = null;
        this.courseTrackingId = null;
        this.badges = null;
        if (pageFor) {
            this.uiRegion = uiRegion + '_' + pageFor;
        } else {
            this.uiRegion = uiRegion;
        }
    }
}

export class SubscriptionLearnMoreEvent implements BaseTrackingEvent {
    readonly _type = 'SubscriptionLearnMoreEvent';
    planPriceId: string;
    planPriceIds: number[] | null;
    planType: string;
    noticeId: number | null;
    url: string | null;
    uiRegion: string;
    constructor({
        uiRegion,
        planPriceId,
        pageFor,
    }: {
        uiRegion: string;
        planPriceId: string;
        pageFor: string | null;
    }) {
        this.planPriceId = planPriceId;
        this.planPriceIds = [Number(planPriceId || 0)];
        this.planType = 'CONSUMERSUBSCRIPTION';
        this.noticeId = null;
        this.url = null;
        if (pageFor) {
            this.uiRegion = uiRegion + '_' + pageFor;
        } else {
            this.uiRegion = uiRegion;
        }
    }
}

/*
class SubscriptionOfferPresented extends ClientEvent {
    primaryPricingOption: SubscriptionPlanPricingOption;
    allPricingOptions: SubscriptionPlanPricingOption[];
    productType: 'consumer' | 'team';
    countryCode: string;
    courseId: number | null;
    courseTrackingId: string | null;
    badges: string[] | null;
    uiRegion: string;

    constructor({
        subscriptionPlan,
        productType,
        countryCode,
        courseId = null,
        courseTrackingId = null,
        badges = null,
        uiRegion,
    }: {
        subscriptionPlan: SubscriptionPlan;
        productType: SubscriptionPlanProductType;
        countryCode: string;
        courseId?: number | null;
        courseTrackingId?: string | null;
        badges?: string[] | null;
        uiRegion: string;
    }) {
        super('SubscriptionOfferPresented');
        const pricingOptions = this.formatPricingOptions(subscriptionPlan);

        this.primaryPricingOption = pricingOptions[0];
        this.allPricingOptions = pricingOptions;
        this.productType = this.mapProductType(productType);
        this.countryCode = countryCode;
        this.courseId = courseId;
        this.courseTrackingId = courseTrackingId;
        this.badges = badges;
        this.uiRegion = uiRegion;
    }

    private mapProductType(planProductType: SubscriptionPlanProductType) {
        return planProductType === 'TEAM' ? 'team' : 'consumer';
    }

    private formatPricingOptions(subscriptionPlan: SubscriptionPlan) {
        return subscriptionPlan.priceOptions.map((option) => ({
            price: option.listPrice.amount,
            listPrice: option.listPrice.amount,
            currency: option.listPrice.currency as string,
            renewalIntervalType: option.renewalInterval.type.toLowerCase() as RenewIntervalType,
            renewalIntervalCount: option.renewalInterval.count,
            hasTrial: !!option.trial?.dateInterval,
            trialDays: option.trial?.dateInterval?.count ?? null,
        }));
    }
}

class SubscriptionLearnMoreEvent extends ClientEvent {
    planPriceId: string;
    planType: SubscriptionPlanProductType;
    uiRegion: string;
    planPriceIds?: number[];
    noticeId?: number | null;

    constructor(
        planId: string,
        planType: SubscriptionPlanProductType,
        uiRegion: string,
        planPriceIds: string[] | null = null,
        noticeId = null,
    ) {
        super('SubscriptionLearnMoreEvent');
        this.planPriceId = parseGlobalIdOrPlanPriceId(planId).toString();
        this.planType = planType;
        this.uiRegion = uiRegion;
        this.planPriceIds = planPriceIds?.map((planPriceId) => getIdFromGlobalId(planPriceId));
        this.noticeId = noticeId;
    }
}
*/
